module.exports = __webpack_public_path__ + "img/art2-img1.48a92696.jpeg";